import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'trucker.dating',
  TITLE: 'Trucker Dating',
  NICHE: 'trucker',
  PROJECT: 'truckerdating',
  NICHE_SINGULAR: 'trucker',
  NICHE_PLURAL: 'truckers',
  FB_TRACKING_PIXEL_ID: ['270346460499156', '938826096876015'],
  BING_TRACKING_PIXEL: ['343094441'],
  SNAPCHAT_TRACKING_PIXEL: '6a7c947b-4d05-4606-bd82-4ae300e7ce65',
  SNAPCHAT_HASHED_EMAIL:
    'e204fed6aff3d35c995bdf6883b099c14dd3b2271ade6d64169ddbfc29204e52',
  VERIZON_TRACKING_PIXEL: '10111277',
  INSTALL_BANNER_KEY: 'af3e5634-0307-42bb-ade1-b9e1b2211e99',
  TABOOLA_TRACKING_PIXEL: '1730669',
  TYPE: 'mainstream',
  SENTRY_RELEASE: 'www-trucker-dating',
  SENTRY_DNS:
    'https://c9352e24b2ae6eee08ed72fd0516d6b1@sentry.nearbyapi.com/11',
});

export default config;



// WEBPACK FOOTER //
// ./src/constants/config.js